import { Div, Flex, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './purchaseOptions.module.scss'

interface PurchaseOptionsProps {
  title: string
  subtitle: string
  isExpenseContainer?: boolean
  kind: 'points' | 'expense'
  amount: number
}

const PurchaseOptions: React.FC<PurchaseOptionsProps> = props => {
  const {
    title,
    subtitle,
    isExpenseContainer = false,
    children,
    kind,
    amount,
  } = props
  const totalAmount =
    kind === 'points' ? amount.toString() : `$${amount.toFixed(2)}`

  return (
    <>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        className={styles.mainContainer}
      >
        <Text type="subtitle" alignment="center">
          {title}
        </Text>
        <Text type="caption" alignment="center">
          {subtitle}
        </Text>
        <Spacer space="x3" />
        <Flex
          alignItems="center"
          justifyContent="center"
          columnGap="x1"
          flexWrap="wrap"
        >
          <Text type="body">You currently have</Text>
          <Div backgroundColor="foreground" className={styles.banner}>
            <Text type="body">{totalAmount}</Text>
          </Div>
          <Text type="body">{kind}.</Text>
        </Flex>
        <Spacer space="x5" />
        <Flex
          className={
            isExpenseContainer
              ? `${styles.optionsContainer} ${styles.expenseContainer}`
              : styles.optionsContainer
          }
        >
          {children}
        </Flex>
      </Flex>
      <Spacer space="x6" />
    </>
  )
}

export default PurchaseOptions
